module.exports = __webpack_public_path__ + "img/happycheck_new.37d41cbc.svg";